<template>
  <div class="home">
    <NotesList/>
  </div>
</template>

<script>
// @ is an alias to /src
import NotesList from '@/components/NotesList.vue';

export default {
  name: 'Home',
  components: {
    NotesList,
  },
};
</script>
